import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About</h2>
        </div>

        <p className="about-text">
          I’m a Lead Solution Developer with over 7 years of experience building
          React‑based web applications and front‑end architectures for domains such as
          aviation, banking and enterprise platforms. I’ve worked with organisations
          like IBS Software, Capgemini and UST, focusing on performance, scalability
          and code quality.
          <br /><br />
          I’m currently based in Newcastle Upon Tyne and have the right to work in the
          UK. I’m particularly interested in freelance and contract roles where I can
          help teams modernise frontends, improve performance, or deliver greenfield
          React applications.
        </p>
      </div>
    </section>
  );
}